const countryTranslations = {
  ad: "আন্ডোরা",
  ae: "সংযুক্ত আরব আমিরাত",
  af: "আফগানিস্তান",
  ag: "অ্যান্টিগুয়া ও বারবুডা",
  ai: "এ্যাঙ্গুইলা",
  al: "আলবেনিয়া",
  am: "আর্মেনিয়া",
  ao: "অ্যাঙ্গোলা",
  ar: "আর্জেন্টিনা",
  as: "আমেরিকান সামোয়া",
  at: "অস্ট্রিয়া",
  au: "অস্ট্রেলিয়া",
  aw: "আরুবা",
  ax: "আলান্ড দ্বীপপুঞ্জ",
  az: "আজারবাইজান",
  ba: "বসনিয়া ও হার্জেগোভিনা",
  bb: "বারবাদোস",
  bd: "বাংলাদেশ",
  be: "বেলজিয়াম",
  bf: "বুরকিনা ফাসো",
  bg: "বুলগেরিয়া",
  bh: "বাহরাইন",
  bi: "বুরুন্ডি",
  bj: "বেনিন",
  bl: "সেন্ট বারথেলিমি",
  bm: "বারমুডা",
  bn: "ব্রুনেই",
  bo: "বলিভিয়া",
  bq: "ক্যারিবিয়ান নেদারল্যান্ডস",
  br: "ব্রাজিল",
  bs: "বাহামা দ্বীপপুঞ্জ",
  bt: "ভুটান",
  bw: "বতসোয়ানা",
  by: "বেলারুশ",
  bz: "বেলিজ",
  ca: "কানাডা",
  cc: "কোকোস (কিলিং) দ্বীপপুঞ্জ",
  cd: "কঙ্গো-কিনশাসা",
  cf: "মধ্য আফ্রিকার প্রজাতন্ত্র",
  cg: "কঙ্গো - ব্রাজাভিল",
  ch: "সুইজারল্যান্ড",
  ci: "কোত দিভোয়ার",
  ck: "কুক দ্বীপপুঞ্জ",
  cl: "চিলি",
  cm: "ক্যামেরুন",
  cn: "চীন",
  co: "কলম্বিয়া",
  cr: "কোস্টারিকা",
  cu: "কিউবা",
  cv: "কেপভার্দে",
  cw: "কুরাসাও",
  cx: "ক্রিসমাস দ্বীপ",
  cy: "সাইপ্রাস",
  cz: "চেচিয়া",
  de: "জার্মানি",
  dj: "জিবুতি",
  dk: "ডেনমার্ক",
  dm: "ডোমিনিকা",
  do: "ডোমেনিকান প্রজাতন্ত্র",
  dz: "আলজেরিয়া",
  ec: "ইকুয়েডর",
  ee: "এস্তোনিয়া",
  eg: "মিশর",
  eh: "পশ্চিম সাহারা",
  er: "ইরিত্রিয়া",
  es: "স্পেন",
  et: "ইথিওপিয়া",
  fi: "ফিনল্যান্ড",
  fj: "ফিজি",
  fk: "ফকল্যান্ড দ্বীপপুঞ্জ",
  fm: "মাইক্রোনেশিয়া",
  fo: "ফ্যারও দ্বীপপুঞ্জ",
  fr: "ফ্রান্স",
  ga: "গ্যাবন",
  gb: "যুক্তরাজ্য",
  gd: "গ্রেনাডা",
  ge: "জর্জিয়া",
  gf: "ফরাসী গায়ানা",
  gg: "গুয়ার্নসি",
  gh: "ঘানা",
  gi: "জিব্রাল্টার",
  gl: "গ্রীনল্যান্ড",
  gm: "গাম্বিয়া",
  gn: "গিনি",
  gp: "গুয়াদেলৌপ",
  gq: "নিরক্ষীয় গিনি",
  gr: "গ্রীস",
  gt: "গুয়াতেমালা",
  gu: "গুয়াম",
  gw: "গিনি-বিসাউ",
  gy: "গিয়ানা",
  hk: "হংকং এসএআর চীনা",
  hn: "হন্ডুরাস",
  hr: "ক্রোয়েশিয়া",
  ht: "হাইতি",
  hu: "হাঙ্গেরি",
  id: "ইন্দোনেশিয়া",
  ie: "আয়ারল্যান্ড",
  il: "ইজরায়েল",
  im: "আইল অফ ম্যান",
  in: "ভারত",
  io: "ব্রিটিশ ভারত মহাসাগরীয় অঞ্চল",
  iq: "ইরাক",
  ir: "ইরান",
  is: "আইসল্যান্ড",
  it: "ইতালি",
  je: "জার্সি",
  jm: "জামাইকা",
  jo: "জর্ডন",
  jp: "জাপান",
  ke: "কেনিয়া",
  kg: "কিরগিজিস্তান",
  kh: "কম্বোডিয়া",
  ki: "কিরিবাতি",
  km: "কমোরোস",
  kn: "সেন্ট কিটস ও নেভিস",
  kp: "উত্তর কোরিয়া",
  kr: "দক্ষিণ কোরিয়া",
  kw: "কুয়েত",
  ky: "কেম্যান দ্বীপপুঞ্জ",
  kz: "কাজাখস্তান",
  la: "লাওস",
  lb: "লেবানন",
  lc: "সেন্ট লুসিয়া",
  li: "লিচেনস্টেইন",
  lk: "শ্রীলঙ্কা",
  lr: "লাইবেরিয়া",
  ls: "লেসোথো",
  lt: "লিথুয়ানিয়া",
  lu: "লাক্সেমবার্গ",
  lv: "লাত্ভিয়া",
  ly: "লিবিয়া",
  ma: "মোরক্কো",
  mc: "মোনাকো",
  md: "মলডোভা",
  me: "মন্টিনিগ্রো",
  mf: "সেন্ট মার্টিন",
  mg: "মাদাগাস্কার",
  mh: "মার্শাল দ্বীপপুঞ্জ",
  mk: "উত্তর ম্যাসেডোনিয়া",
  ml: "মালি",
  mm: "মায়ানমার (বার্মা)",
  mn: "মঙ্গোলিয়া",
  mo: "ম্যাকাও এসএআর চীনা",
  mp: "উত্তরাঞ্চলীয় মারিয়ানা দ্বীপপুঞ্জ",
  mq: "মার্টিনিক",
  mr: "মরিতানিয়া",
  ms: "মন্টসেরাট",
  mt: "মাল্টা",
  mu: "মরিশাস",
  mv: "মালদ্বীপ",
  mw: "মালাউই",
  mx: "মেক্সিকো",
  my: "মালয়েশিয়া",
  mz: "মোজাম্বিক",
  na: "নামিবিয়া",
  nc: "নিউ ক্যালেডোনিয়া",
  ne: "নাইজার",
  nf: "নরফোক দ্বীপ",
  ng: "নাইজেরিয়া",
  ni: "নিকারাগুয়া",
  nl: "নেদারল্যান্ডস",
  no: "নরওয়ে",
  np: "নেপাল",
  nr: "নাউরু",
  nu: "নিউয়ে",
  nz: "নিউজিল্যান্ড",
  om: "ওমান",
  pa: "পানামা",
  pe: "পেরু",
  pf: "ফরাসী পলিনেশিয়া",
  pg: "পাপুয়া নিউ গিনি",
  ph: "ফিলিপাইন",
  pk: "পাকিস্তান",
  pl: "পোল্যান্ড",
  pm: "সেন্ট পিয়ের ও মিকুয়েলন",
  pr: "পুয়ের্তো রিকো",
  ps: "প্যালেস্টাইনের অঞ্চলসমূহ",
  pt: "পর্তুগাল",
  pw: "পালাউ",
  py: "প্যারাগুয়ে",
  qa: "কাতার",
  re: "রিইউনিয়ন",
  ro: "রোমানিয়া",
  rs: "সার্বিয়া",
  ru: "রাশিয়া",
  rw: "রুয়ান্ডা",
  sa: "সৌদি আরব",
  sb: "সলোমন দ্বীপপুঞ্জ",
  sc: "সিসিলি",
  sd: "সুদান",
  se: "সুইডেন",
  sg: "সিঙ্গাপুর",
  sh: "সেন্ট হেলেনা",
  si: "স্লোভানিয়া",
  sj: "স্বালবার্ড ও জান মেয়েন",
  sk: "স্লোভাকিয়া",
  sl: "সিয়েরা লিওন",
  sm: "সান মারিনো",
  sn: "সেনেগাল",
  so: "সোমালিয়া",
  sr: "সুরিনাম",
  ss: "দক্ষিণ সুদান",
  st: "সাওটোমা ও প্রিন্সিপি",
  sv: "এল সালভেদর",
  sx: "সিন্ট মার্টেন",
  sy: "সিরিয়া",
  sz: "ইসওয়াতিনি",
  tc: "তুর্কস ও কাইকোস দ্বীপপুঞ্জ",
  td: "চাদ",
  tg: "টোগো",
  th: "থাইল্যান্ড",
  tj: "তাজিকিস্তান",
  tk: "টোকেলাউ",
  tl: "তিমুর-লেস্তে",
  tm: "তুর্কমেনিস্তান",
  tn: "তিউনিসিয়া",
  to: "টোঙ্গা",
  tr: "তুরস্ক",
  tt: "ত্রিনিনাদ ও টোব্যাগো",
  tv: "টুভালু",
  tw: "তাইওয়ান",
  tz: "তাঞ্জানিয়া",
  ua: "ইউক্রেন",
  ug: "উগান্ডা",
  us: "মার্কিন যুক্তরাষ্ট্র",
  uy: "উরুগুয়ে",
  uz: "উজবেকিস্তান",
  va: "ভ্যাটিকান সিটি",
  vc: "সেন্ট ভিনসেন্ট ও গ্রেনাডিনস",
  ve: "ভেনেজুয়েলা",
  vg: "ব্রিটিশ ভার্জিন দ্বীপপুঞ্জ",
  vi: "মার্কিন যুক্তরাষ্ট্রের ভার্জিন দ্বীপপুঞ্জ",
  vn: "ভিয়েতনাম",
  vu: "ভানুয়াটু",
  wf: "ওয়ালিস ও ফুটুনা",
  ws: "সামোয়া",
  ye: "ইয়েমেন",
  yt: "মায়োত্তে",
  za: "দক্ষিণ আফ্রিকা",
  zm: "জাম্বিয়া",
  zw: "জিম্বাবোয়ে"
};
export default countryTranslations;
